<template>
    <tab-section title="Project">
        <div v-if="!!record" class="uk-grid uk-grid-small" data-uk-grid-margin>
            <div class="uk-width-1-1">
                <div
                    id="project-type-title"
                    :class="{'uk-text-required': !record.category_ids||!record.category_ids.length}"
                    class="uk-form-controls-text uk-text-bold"
                >
                    <open-icon v-if="!record.category_ids||!record.category_ids.length" glyph="exclamation-triangle" />
                    Project Types
                </div>
                <category-picker
                    id="project"
                    v-model="record.category_ids"
                    :filtered="project_is_overhead(record) ? 'overhead' : 'regular'"
                    :editable="editable"
                    title="Project Type(s)"
                    subtitle="Please limit selections (typically 1-2 per category) and only include major and important spaces in Project Keywords"
                    @change="toggle_category"
                />
            </div>
            <div v-if="!project_is_overhead(record)" class="uk-width-1-2 uk-margin-top">
                <div id="project-size-title" :class="{'uk-text-required': !record.size}" class="uk-form-controls-text uk-text-bold">
                    <open-icon v-if="!record.size" glyph="exclamation-triangle" />
                    Project Size
                </div>
                <form-size-control
                    id="size"
                    name="size"
                    unit-name="size_units"
                    :value="record"
                    :required="false"
                    :editable="editable"
                    @input="save_field"
                    class="uk-width-1-1"
                />
            </div>

            <div v-if="!project_is_overhead(record)" :class="{'lam-lower-contrast': !!wizardShown}" class="uk-width-1-2 uk-margin-top">
                <div class="uk-form-controls-text uk-text-bold">
                    <open-icon glyph="random" class="uk-text-muted" />
                    Related Lam Projects
                </div>
                <project-picker
                    id="related_projects"
                    name="related_projects"
                    :value="related_project_ids"
                    :editable="editable"
                    group-field="relationship_id"
                    instructions="(Type-in a project name, nickname or number)"
                    class="uk-margin-bottom"
                    @pick="save_field"
                />
            </div>
        </div>
    </tab-section>
</template>

<script type="text/javascript">
import { mapGetters } from "vuex"

import is_project_tab_section from "../mixins/IsProjectTabSection"
import project_utilities from "../../../mixins/ProjectUtilities"

import FormSizeControl from "../../../ui/FormSizeControl"
import CategoryPicker from "../../../ui/CategoryPicker"
import ProjectPicker from "../../../ui/ProjectPicker"
import OpenIcon from "../../../ui/OpenIcon"

export default {
    mixins: [is_project_tab_section, project_utilities],
    components: {
        FormSizeControl,
        CategoryPicker,
        ProjectPicker,
        OpenIcon
    },
    methods: {
        toggle_category (checked, category_id) {
            const index = this.record.category_ids.indexOf(category_id)
            if(checked && (index < 0)) this.record.category_ids.push(category_id)
            else if(!checked && (index >= 0)) this.record.category_ids.splice(index, 1)
            this.save_field(this.record.category_ids, "category_ids")
        }
    },
    computed: {
        ...mapGetters(["entity_records"]),
        raw_project_records () {
            return this.$store.getters.entity_records("project")
        },
        related_project_ids () {
            if(!this.record || !this.record.relationship_id) return []
            return this.raw_project_records.filter(project => (project.id !== this.record.id) && (project.relationship_id === this.record.relationship_id)).map(project => project.id)
        }
    }
}
</script>
